import React from 'react';
import { Modal, Form, Input, Spin } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { CLEAR_ERRORS } from '../../state/error/types';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

const { TextArea } = Input;

const ModalDemurContract = ({ ...props }) => {

  const [form] = Form.useForm();

  return (
    <Modal
      visible={props.visible}
      title="Mensaje de objetar documento"
      okText="Enviar"
      cancelText="Cancelar"
      maskClosable={false}
      onCancel={props.onCancel}
      afterClose={() => props.clearErrors()}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            props.onCreate(values.demur_message);
          });
      }}
      okButtonProps={{ disabled: props.spinning }}
      cancelButtonProps={{ disabled: props.spinning }}
    >
      <Spin
        spinning={props.spinning}
        size="large"
        indicator={spinnerIcon}
      >
        <Form
          form={form}
          layout="vertical"
          name="demur_contract_modal"
        >
          <Form.Item
            name="demur_message"
            label="Escribe un mensaje a arrendador, explicando las razones del porqué decidiste objetar este documento."
            rules={[
              { required: true, message: 'Por favor ingrese el motivo' },
            ]}
          >
            <TextArea placeholder="Escribir mensaje" showCount maxLength={200} rows={4} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalDemurContract.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  spinning: PropTypes.bool.isRequired,
  spinnerIcon: PropTypes.object,
};

const action = (dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(null, action)(ModalDemurContract);